import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { BaseCompetitionsStoreElement, CompetitionsActionType, CompetitionsStore } from './CompetitionsReducer.types';

// @ts-ignore
const initialState: CompetitionsStore = Immutable.fromJS({
  data: Immutable.List(),
  levelsOptions: Immutable.Map(),
  isFetching: false,
  isLevelsFetching: false,
  failure: false,
});

const formatCompetitionsLevels = (levels: any) => {
  const competitionsLevels: any = {};
  levels.map((level: any) => {
    competitionsLevels[level.id] = level.name;
  });

  return competitionsLevels;
};

const CompetitionsReducer = handleActions(
  {
    DASHBOARD_COMPETITIONS_REQUEST: (state: CompetitionsStore) => state.set('isFetching', true),

    DASHBOARD_COMPETITIONS_RESPONSE_FAILURE: (state: CompetitionsStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_COMPETITIONS_RESPONSE: (state: CompetitionsStore, action: CompetitionsActionType) =>
      state.merge(
        Immutable.fromJS({
          isFetching: false,
          failure: false,
          data: Immutable.fromJS(
            action.payload.data.results.filter(
              (competitions: BaseCompetitionsStoreElement) => competitions.status === 'ACCEPTED' || competitions.status === 'REQUIRED'
            )
          ),
        })
      ),
    REQUEST_COMPETITIONS_LEVELS: state => state.set('isLevelsFetching', true),
    RESPONSE_COMPETITIONS_LEVELS_SUCCESS: (state: CompetitionsStore, action: CompetitionsActionType) =>
      state
        .set('isFetching', false)
        .set('isLevelsFetching', false)
        .set('levelsOptions', Immutable.fromJS(formatCompetitionsLevels(action.payload))),
  },
  initialState
);

export default CompetitionsReducer;
